import(/* webpackMode: "eager" */ "/vercel/path0/apps/lms/src/app/inhouse-training/page.tsx");
